var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { Logger, LoggerLevel } from './logger';
import { identity, pick } from 'ramda';
import { BehaviorSubject } from 'rxjs';
import { filter, debounceTime, shareReplay } from 'rxjs/operators';
import { isMobile } from '../utils/_.utils';
import { isFormElement } from '../../models';
import { XbpmContext } from '../context';
var LOGGER_NAME = 'xbpm-logger';
var LOGGER_COMMIT_DEBOUNCE = 10000;
var LOGGER_LOG_LEVEL_VARIABLE = 'LOG_LEVEL';
var clearElement = pick(['name', 'label', 'code', 'kind', 'hidden', 'disabled', 'readonly']);
export var loggerElement2Str = function (element) { return "" + JSON.stringify(clearElement(element)); };
export var loggerArr2Str = function (items) { return "[" + items.map(loggerObj2Str).join(',') + "]"; };
export var loggerObj2Str = function (it) {
    try {
        return typeof it === 'object'
            ? Array.isArray(it)
                ? loggerArr2Str(it)
                : isFormElement(it)
                    ? loggerElement2Str(it)
                    : JSON.stringify(it)
            : "" + it;
    }
    catch (_a) {
        return "" + it;
    }
};
var loggerMessage2Str = function (msg) {
    return !msg
        ? ''
        : msg
            .map(function (it) {
            if (it instanceof Error) {
                return [it.name, it.message].filter(function (x) { return !!x; }).join(': ');
            }
            return loggerObj2Str(it);
        })
            .join('\n');
};
var XbpmLogger = /** @class */ (function () {
    function XbpmLogger(config) {
        var _this = this;
        if (config === void 0) { config = {}; }
        this.config = config;
        this.buffer$ = new BehaviorSubject([]);
        this.commit$ = this.buffer$.pipe(debounceTime(LOGGER_COMMIT_DEBOUNCE), filter(function (x) { return !!x.length; }), shareReplay(1));
        this.adapter = function (event) {
            _this.buffer$.next(__spreadArrays(_this.buffer$.getValue(), [event.data[0]]));
        };
        this.onLog = function (target, level) { return function (message) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            var log = __assign(__assign({ source: _this.source, logLevel: level.toUpperCase() }, target), { eventMessage: loggerMessage2Str(__spreadArrays([message], args)) });
            return _this.logger[level](log);
        }; };
        this.getFormLogger = function (formInfo) { return function (targetInfo) {
            return _this.getElementLogger(__assign(__assign({}, formInfo), targetInfo));
        }; };
        this.getElementLogger = function (target) { return ({
            log: _this.onLog(target, LoggerLevel.DEBUG),
            logInfo: _this.onLog(target, LoggerLevel.INFO),
            logWarn: _this.onLog(target, LoggerLevel.WARN),
            logDebug: _this.onLog(target, LoggerLevel.DEBUG),
            logError: _this.onLog(target, LoggerLevel.ERROR),
            logTrace: _this.onLog(target, LoggerLevel.TRACE),
        }); };
        this.commit = function () {
            var buffer = _this.buffer$.getValue();
            if (!!buffer.length) {
                _this.buffer$.next([]);
                var send = _this.config.sendLogs || XbpmContext.getContext().apiService.logFormulas;
                send(buffer).then(identity, function (_) {
                    _this.buffer$.next(__spreadArrays(buffer, _this.buffer$.getValue()));
                });
            }
        };
        // init logger
        this.logger = new Logger({
            name: LOGGER_NAME,
            variable: LOGGER_LOG_LEVEL_VARIABLE,
            adapter: this.adapter,
        });
        // commit log buffer
        this.commit$.subscribe(this.commit);
    }
    Object.defineProperty(XbpmLogger.prototype, "source", {
        get: function () {
            return isMobile() ? 'MOBILE' : 'FRONTEND';
        },
        enumerable: true,
        configurable: true
    });
    return XbpmLogger;
}());
export { XbpmLogger };
//# sourceMappingURL=xbpm-logger.js.map